import React, { useMemo } from "react";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import RichTextRenderer from "@icarius-table/renderersAndFilters/richTextRenderer";
import QuestionFormDialog from "./questionFormDialog";
import useQuestions from "./useQuestions";

const QuestionsPage = (props) => {

  const {
    readOnly,
    questions,
    questionTypes,
    submitCallback,
  } = props;

  const formattedQuestions = useMemo(() => {
    return questions.map((question, questionIndex,) => {
      return ({
        ...question,
        index: questionIndex,
        typeString: questionTypes.find((type) => type.key === question.type)?.value,
        optionsAmount: question.answers?.length || 0,
      })
    })
  }, [questionTypes, questions])

  const {
    state,
    handlers,
  } = useQuestions(formattedQuestions, submitCallback);

  const createButton = () => !readOnly && (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateQuestionForm()}
      type={"add"}
    />
  )

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateQuestionForm(gridRef)}
      type={"edit"}
    />
  )

  const deleteButton = (gridRef) => !readOnly && (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteQuestionDialog(gridRef)}
      type={"delete"}
    />
  )

  return (
    <CommonPage
      title={getLocalizedString("questions")}
      columnDefPage={"/coursesMaster/questions"}
      rowData={formattedQuestions}
      gridHeight={300}
      menuItems={[createButton, editButton, deleteButton]}
      ignoreProcessesbyPath
      frameworkComponents={{ RichTextRenderer }}
    >
      {
        state.questionFormIsOpen &&
        <QuestionFormDialog
          open={state.questionFormIsOpen}
          readOnly={readOnly}
          data={state.selectedQuestion}
          questionTypes={questionTypes}
          submitCallback={state.selectedQuestion ? handlers.handleUpdateQuestion : handlers.handleCreateQuestion}
          handleClose={handlers.handleCloseQuestionForm}
        />
      }
    </CommonPage>
  )
}

export default QuestionsPage;